module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('strong', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226925233_05_int#int"
    }
  }, [_c('em', [_vm._v("Introduction: Execrable Media")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('em', [_vm._v("Alexander R. Galloway, Eugene Thacker, McKenzie Wark")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226925233_06_ch1#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LOVE OF THE MIDDLE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Alexander R. Galloway")]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226925233_07_ch2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DARK MEDIA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Eugene Thacker")]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226925233_08_ch3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FURIOUS MEDIA: A QUEER HISTORY OF HERESY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("McKenzie Wark")]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226925233_09_not",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f3ff444","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226925233_04_toc.vue
// module id = 66
// module chunks = 0